import { ApiResponse } from "@/types";
import api from "./api";

interface PresignedUrlDto {
  key: string;
  url: string; // presigned url
}

export const StorageService = {
  publicFileWithPresignedUrl: async (presignedUrls: string, file: File) => {
    await fetch(presignedUrls, {
      method: "PUT",
      body: file,
      headers: {
        "Content-Type": file.type,
      },
    });
  },

  // Create public url: url = {key}.{file extension}
  createPublicUrlS3: (key: string, _: File) => {
    return key;
    // return `${key}.${file.name.split(".").pop()}`;
    // return `https://${process.env.NEXT_PUBLIC_S3_BUCKET}.s3.${process.env.NEXT_PUBLIC_S3_REGION}.amazonaws.com/${key}`;
  },

  createPresignedUrls: async (files: File[]) => {
    const res = await api.post<ApiResponse<PresignedUrlDto[]>>(
      "/storage/presigned",
      { files: files.map((file) => ({ name: file.name, type: file.type })) }
    );
    return res.data.data;
  },

  getDownloadUrl: async (url: string, name?: string) => {
    const res = await api.get<ApiResponse<{ url: string }>>(
      "/storage/download-url",
      { params: { url, name } }
    );
    return res.data.data.url;
  },

  uploadFiles: async (files: File[]): Promise<(string | false)[]> => {
    // create presigned url
    const presignedUrls = await StorageService.createPresignedUrls(files);

    // public file to s3 with presigned url
    // if file success return public url else return false
    const result = await Promise.allSettled(
      presignedUrls.map((dto, index) =>
        StorageService.publicFileWithPresignedUrl(dto.url, files[index])
      )
    );

    // Create public url
    return result.map((result, index) => {
      return result.status === "fulfilled"
        ? StorageService.createPublicUrlS3(
            presignedUrls[index].key,
            files[index]
          )
        : false;
    });
  },
};
